// "Debit notes" only exists under managed payouts — a self-payout brand pays its
// publishers directly, so nothing is ever raised against it and the tab would be a
// permanently empty table.
export const getBrandDetailTabs = ({ debitNotes = true } = {}) => [
    { id: "overview", label: "Overview" },
    { id: "kyc", label: "KYC" },
    { id: "contract", label: "Contract" },
    { id: "publishers", label: "Publishers" },
    ...(debitNotes ? [{ id: "debit-notes", label: "Debit notes" }] : []),
    { id: "payment-history", label: "Payment history" }
];
